import TtamCreativeDeepLinkInput from './input/index.vue';
import TtamCreativeDeepLinkFallbackInput from './fallback-input/index.vue';
import TtamCreativeDeepLinkFallbackType from './fallback-type/index.vue';
import TtamCreativeDeepLinkFallbackTypeSelect from './fallback-type-select/index.vue';
import TtamCreativeDeepLinkPreviewDialog from './preview-dialog/index.vue';

import TtamCreativeDeepLinkSwitch from './switch/index.vue';
import TtamCreativeDeepLinkDpaSelect from './dpa-select/index.vue';
import TtamCreativeDeepLinkDpaInputFormLabel from './dpa-input-form-label/index.vue';

import * as hooks from './hooks';
export default {
  TtamCreativeDeepLinkInput,
  TtamCreativeDeepLinkFallbackInput,
  TtamCreativeDeepLinkFallbackType,
  TtamCreativeDeepLinkFallbackTypeSelect,
  TtamCreativeDeepLinkPreviewDialog,
  TtamCreativeDeepLinkSwitch,
  TtamCreativeDeepLinkDpaSelect,
  TtamCreativeDeepLinkDpaInputFormLabel,
  ...hooks,
};
